import * as React from "react";
import Fade from "@mui/material/Fade";
import { Menu, styled } from "@mui/material";
import { ThemeEnum } from "../../../core/enumerations/ThemeEnum";

const MuiMenu = (props: any) => {
  const {
    anchorEl,
    open,
    handleClose,
    children,
    selectedmenuoption,
    position,
  } = props;

  interface IMenuStyles {
    selectedmenuoption: string;
  }

  const MenuStyles = styled(Menu)<IMenuStyles>`
    margin: 20px;
    width: 100%;
    height: auto;

    &&& .MuiPaper-root {
      background-color: ${({ selectedmenuoption }: any) =>
        selectedmenuoption === ThemeEnum.dark.toLowerCase()
          ? "var(--tertiary-lite-grey-color)"
          : "var(--white-color)"};
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: right;
      box-shadow: none;
      min-width: 150px;
    }
    &&& .MuiMenuItem-root {
      color: var(--nonary-grey-color);
      min-width: 120px;
    }

    &&& .border-style {
      position: relative;
      width: 100%;
      border-bottom: solid 0.6px #2f3238;
      cursor: pointer;
      margin: auto;
    }

    &&& .menu-items {
      font-family: "Comfortaa-Light";
      color: ${({ selectedmenuoption }: any) =>
        selectedmenuoption === ThemeEnum.dark.toLowerCase()
          ? "var(--nonary-grey-color)"
          : "var(--tertiary-lite-grey-color)"};
      font-size: 1.4rem;
      font-weight: 300;
      cursor: pointer;
      text-align: end;
    }

    &&& .menu-item-disabled {
      font-family: "Comfortaa-Light";
      color: ${({ selectedmenuoption }: any) =>
        selectedmenuoption === ThemeEnum.dark.toLowerCase()
          ? "var(--quaternary-lite-grey-color)"
          : "var(--tertiary-lite-grey-color)"};
      font-size: 1.4rem;
      font-weight: 300;
    }

    &&& .profile-name {
      font-family: "Comfortaa-Bold";
      color: var(--nonary-grey-color);
      font-size: 1.6rem;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
    }

    &&& .profile-name-disabled {
      font-family: "Comfortaa-Bold";
      color: var(--quaternary-lite-grey-color);
      font-size: 1.6rem;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
    }
    @media screen and (max-width: 840px) {
      &&& .menu-items {
        font-size: 1.2rem;
        padding: 0.5rem 1.5rem;
      }
      &&& .menu-item-disabled {
        font-size: 1.2rem;
        padding: 0.5rem 1.5rem;
      }
    }
  `;

  return (
    <MenuStyles
      {...props}
      id="menu-button"
      MenuListProps={{
        "aria-labelledby": "fade-button",
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      TransitionComponent={Fade}
      anchorOrigin={
        position?.anchorOrigin
          ? position?.anchorOrigin
          : { vertical: "bottom", horizontal: "right" }
      }
      transformOrigin={
        position?.transformOrigin
          ? position?.transformOrigin
          : { vertical: "top", horizontal: "right" }
      }
      // sx={{
      //   "& .MuiPaper-root": {
      //     top: "20px !important", // Adjust this value to change the top position
      //   },
      // }}
      selectedmenuoption={selectedmenuoption}
    >
      {children}
    </MenuStyles>
  );
};

export default MuiMenu;
